export const DEFAULT_STARTING_DATE = "01/01/2022";
export const userRoles={
    ACC_MANAGER : 'nKYaQN_LL2rq-VNpies3gw==',
    ADMIN :  'AaM1tJNSe-5R8iUd4tf0uw==',
    AGGREGATOR : 'ZwYhBtOmg8M7hmeNebQuqg=='
}
export const ACC_MANAGER = 'ACC_MANAGER';
export const CHILD_AGGREGATOR_READWRITE = 'CHILD_AGGREGATOR_READWRITE'
export const CHILD_AGGREGATOR_READONLY = 'CHILD_AGGREGATOR_READONLY'
